var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProfileBuilderEducation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 61.519,
    height: 47,
    viewBox: "0 0 61.519 47",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "open-book",
    transform: "translate(0 -35.048)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_48364",
    "data-name": "Group 48364",
    transform: "translate(0 35.048)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_48363",
    "data-name": "Group 48363",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55643",
    "data-name": "Path 55643",
    d: "M37.028,35.049h-.005a2.17,2.17,0,0,0-1.542.639,2.192,2.192,0,0,0-.648,1.562v33.01a2.209,2.209,0,0,0,2.2,2.2c5.124.012,13.709,1.08,19.632,7.278V45.193a2.11,2.11,0,0,0-.3-1.115C51.505,36.25,42.164,35.061,37.028,35.049Z",
    transform: "translate(-27.618 -35.049)",
    fill: "#387f75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55644",
    "data-name": "Path 55644",
    d: "M178.587,70.26V37.249a2.192,2.192,0,0,0-.648-1.562,2.17,2.17,0,0,0-1.542-.639h-.005c-5.136.012-14.477,1.2-19.338,9.03a2.109,2.109,0,0,0-.3,1.115V79.739c5.922-6.2,14.507-7.266,19.632-7.278A2.209,2.209,0,0,0,178.587,70.26Z",
    transform: "translate(-124.282 -35.048)",
    fill: "#387f75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55645",
    "data-name": "Path 55645",
    d: "M195.28,71.8h-1.6V99.4a5.632,5.632,0,0,1-5.614,5.619c-4.346.01-11.513.86-16.588,5.664,8.778-2.149,18.032-.752,23.305.45a2.2,2.2,0,0,0,2.694-2.145V74A2.2,2.2,0,0,0,195.28,71.8Z",
    transform: "translate(-135.962 -64.188)",
    fill: "#387f75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55646",
    "data-name": "Path 55646",
    d: "M3.8,99.4V71.8H2.2A2.2,2.2,0,0,0,0,74v34.985a2.2,2.2,0,0,0,2.694,2.145c5.274-1.2,14.528-2.6,23.305-.45-5.075-4.8-12.242-5.653-16.588-5.664A5.632,5.632,0,0,1,3.8,99.4Z",
    transform: "translate(0 -64.188)",
    fill: "#387f75"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileBuilderEducation);
export default __webpack_public_path__ + "static/media/profile-builder-education.c704b938d6862c7b84466ed133caea37.svg";
export { ForwardRef as ReactComponent };